export default "__VITE_ASSET__mjYD9kf0__"